module.exports = __webpack_public_path__ + "src/app/_content/imgs/discover/mot/Black-Collection.jpg?b5326f2bce36425d4715b5f86d821627";